// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__3USR9","errorLogs":"EditorFooter_errorLogs__37-Fw"};